module.exports = __webpack_public_path__ + "static/media/two-person-in-long-sleeved-shirt-shakehand-955395.38f5457f.jpg";